import { render, staticRenderFns } from "./EstimatesOldPageMaterialList.vue?vue&type=template&id=07832902&"
import script from "./EstimatesOldPageMaterialList.vue?vue&type=script&lang=js&"
export * from "./EstimatesOldPageMaterialList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports